<template>
  <a :class="buttonClass" @click="() => {
    sendYmTarget();
    routePage()
  }">
    <svg v-if="nameImage" :class="svgClass" width="25px" height="30px">
      <use :xlink:href="svgHref"></use>
    </svg>
    <p v-if="title" class="function-button__text">{{ title }}</p>
  </a>
</template>
<script>
/* global ym */
export default {
  name: 'ButtonRoute',
  props: {
    title: {
      type: String,
      default: null,
    },
    nameImage: {
      type: String,
      default: null,
    },
    route: {
      type: String,
      default: null,
    },
    nameButton: {
      type: String,
      default: null,
    },
    ymIdTarget: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      svgClass: 'function-button__image',
      svgHref: null,
      buttonClass: 'button function-button',
    }
  },
  created() {
    if (this.svgClass) {
      this.svgClass = `${this.svgClass} ${this.svgClass}_${this.nameImage}`;
    }
    this.svgHref = `#${this.nameImage}`;
    if (this.nameButton) {
      this.buttonClass = `${this.buttonClass} function-button_${this.nameButton}`;
    }
  },
  methods: {
    routePage() {
      if (this.route) {
        window.location.pathname = this.route;
      }
    },
    sendYmTarget() {
      if (this.ymIdTarget && typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', this.ymIdTarget);
      }
    },
  },
};
</script>
